module.exports = __webpack_public_path__ + "img/single.23b43117.svg";